import { render } from "./form-setting.html?vue&type=template&id=70da123e&scoped=true&ts=true"
import script from "./form-setting.ts?vue&type=script&lang=ts"
export * from "./form-setting.ts?vue&type=script&lang=ts"

import "./form-setting.scss?vue&type=style&index=0&id=70da123e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70da123e"]])

export default __exports__